/**
 * /tenants/$slug/agents/integrate — layout for the Integrate area.
 *
 * Owns the area's single page shell (breadcrumbs + one <h1> + the tab strip) and renders
 * each tab's body through <Outlet/>, so every tab shares the same chrome and their own
 * section titles stay <h2>s. Same "section layout owns the tabs" pattern as the
 * Authentication hub.
 *
 * Every page under it is static content — no search params, nothing to prefetch — so
 * there is no loader here by design.
 */

import { createFileRoute, getRouteApi, Outlet } from "@tanstack/react-router";
import { Breadcrumbs, PageHeader } from "@pureid/ui";
import { IntegrateTabs } from "@/features/agent-integrate/components/integrate-tabs";

export const Route = createFileRoute("/_authed/tenants/$slug/agents/integrate")({
  component: IntegrateLayout,
});

const tenantRouteApi = getRouteApi("/_authed/tenants/$slug");

function IntegrateLayout() {
  const { slug } = Route.useParams();
  const { tenant } = tenantRouteApi.useRouteContext();

  return (
    <div className="space-y-6">
      <Breadcrumbs
        items={[
          { label: "Tenants", href: "/tenants" },
          { label: tenant.name, href: `/tenants/${slug}` },
          { label: "Non-human identities", href: `/tenants/${slug}/non-human-identities` },
          // Routed through "How it works" since 2026-08-16: Integrate lost its rail entry
          // and is entered from that page, so the trail has to show the way back up to it.
          {
            label: "How it works",
            href: `/tenants/${slug}/non-human-identities/overview`,
          },
          { label: "Integrate" },
        ]}
      />
      <PageHeader title="Integrate" />
      <IntegrateTabs tenantSlug={slug} />
      <Outlet />
    </div>
  );
}
